import {getUserStats, saveUserStats} from "./UserStatsService";

export const registerTemplateStats = (subjectKey, templateId, problemRating, isCorrect) => {
    const stats = getUserStats();
    const template = filterTemplate(stats, subjectKey, templateId);
    if (isCorrect) {
        template.correctRating = (template.correctCount * template.correctRating + problemRating) / (template.correctCount + 1);
    } else {
        template.incorrectRating = (template.incorrectCount * template.incorrectRating + problemRating) / (template.incorrectCount + 1);
    }
    template.correctCount += isCorrect ? 1 : 0;
    template.incorrectCount += isCorrect ? 0 : 1;
    template.lastDate = new Date();
    saveUserStats(stats);
}

export const getTemplateStats = (subjectKey, templateId) => {
    const stats = getUserStats();
    return filterTemplate(stats, subjectKey, templateId);
}

const filterTemplate = (stats, subjectKey, templateId) => {
    const templateKey = "templates";
    if (!(templateKey in stats)) {
        stats[templateKey] = [];
    }
    const templates = stats[templateKey];
    let template = templates.filter(t => t.id === templateId && t.subjectKey === subjectKey)[0];
    if (!template) {
        template = {
            id: templateId,
            subjectKey: subjectKey,
            correctRating: 0,
            incorrectRating: 0,
            correctCount: 0,
            incorrectCount: 0,
        };
        templates.push(template);
    }

    return template;
}